document.addEventListener("click", function (e) {
  // 点击打开弹窗
  if (e.target.classList.contains("icon_text_click-text")) {
    const id = e.target.getAttribute("id");
    const popup = document.querySelector(`.popup-box[data-popup="${id}"]`);
    if (popup) popup.classList.add("active");
  }

  // 点击关闭（X 按钮 或者遮罩）
  if (
    e.target.classList.contains("popup-overlay") ||
    e.target.classList.contains("popup-close")
  ) {
    e.target.closest(".popup-box").classList.remove("active");
  }
});
